import { Box, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { I18n } from 'utils/i18n';

const AnalyticsToolbar = () => {
  return (
    <Toolbar
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        pr: 1,
        mb: '16px',
        mt: '24px',
      }}
    >
      <Typography component="div" sx={{ fontWeight: 600 }} variant="h5">
        {I18n.t('Header.tabs.Analytics')}
      </Typography>
      <Box sx={{ display: 'flex' }} />
    </Toolbar>
  );
};

export default AnalyticsToolbar;
